import { BucketDef } from './bucket-def';
import { BucketingStrategy } from './bucketing-strategy';
import { BaseBucketingStrategy } from './base-bucketing-strategy';

export class ALMRepricingBucketing extends BaseBucketingStrategy implements BucketingStrategy {
    constructor(todayStr: string, expandFirstBucket?: boolean) {
        super(todayStr, expandFirstBucket);
    }
    initBucketDefs(): void {
        this.bucketDefs.push(new BucketDef(this.today.clone().add(1, 'days'), this.startOfNextBucket(), true, '1D'));
        this.bucketDefs.push(new BucketDef(this.today.clone().add(1, 'week'), this.startOfNextBucket(), true, '1W'));
        this.bucketDefs.push(new BucketDef(this.today.clone().add(2, 'week'), this.startOfNextBucket(), true, '2W'));
        this.bucketDefs.push(new BucketDef(this.today.clone().add(3, 'week'), this.startOfNextBucket(), true, '3W'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 1, true), this.startOfNextBucket(), true, '1M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 2, true), this.startOfNextBucket(), true, '2M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 3, true), this.startOfNextBucket(), true, '3M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 4, true), this.startOfNextBucket(), true, '4M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 5, true), this.startOfNextBucket(), true, '5M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 6, true), this.startOfNextBucket(), true, '6M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 7, true), this.startOfNextBucket(), true, '7M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 8, true), this.startOfNextBucket(), true, '8M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 9, true), this.startOfNextBucket(), true, '9M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 10, true), this.startOfNextBucket(), true, '10M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 11, true), this.startOfNextBucket(), true, '11M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 12, true), this.startOfNextBucket(), true, '1Y'));
    }

    strategyName(): string {
        return 'ALMRepricing';
    }
}
